import { canRouteTo, navigateTo } from '~/spa/navigate';

/**
 * Whether a link can be followed inside the router, or has to go through the server.
 * SimpleLink, SimpleWrapperLink, FolderButton and the wrapper link all ask this to decide
 * between a <router-link> and an <a href>.
 *
 * It used to answer "no" for a link into another section, because a section was seeded from
 * what django rendered into the document it was served with. Nothing is seeded from the
 * document any more - every section fetches its own data, its `setup` runs on entry rather
 * than once per page load, `ensureStoreModule` keeps the modules two sections share from
 * resetting each other, and each section now carries its own <head>. So the router
 * resolving a link is enough.
 *
 * `$user` is still rendered into the document, but it describes the viewer rather than the
 * page: it says the same thing on both sides of a section boundary. A navigation that
 * *changes* the viewer - a login, a logout, an account deletion - still has to reach the
 * server, and those call sites say so.
 *
 * The answer itself lives in `~/spa/navigate`, so that the code navigating without a link
 * to click decides it the same way.
 */
export default {
    methods: {
        getRouterAvailability (link) {
            return canRouteTo(link);
        },
        /** Go there, inside the router when it can be, through the server when it cannot. */
        navigateTo (link) {
            return navigateTo(link);
        },
    }
};
